import Dashboard from "../pages/impex/Dashboard";
import ForecastOrders from "../pages/impex/ForecastOrders";
import GoodsReceivedNote from "../pages/impex/GoodsReceivedNote";
import PurchaseOrders from "../pages/impex/PurchaseOrders";
import Invoices from "../pages/impex/Invoices";
import * as perm from "./../global-const/permissionName";
import QualityCheck from "../pages/impex/QualityCheck";
import InvoiceDetails from "../pages/impex/InvoiceDetails";
import AdminAccess from "../pages/admin/AdminAccess";

export const authenticatedRoutes = [
  {
    pathName: "dashboard",
    view: <Dashboard />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "purchase-orders/:POID",
    view: <PurchaseOrders />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "purchase-orders/:POID/:module",
    view: <PurchaseOrders />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "forecast-orders",
    view: <ForecastOrders />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "good-received-note/:ReceiptId",
    view: <GoodsReceivedNote />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "quality-check/:ReceiptId",
    view: <QualityCheck />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "invoices",
    view: <Invoices />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "invoices/:POID",
    view: <InvoiceDetails />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.ImpexOperations,
      perm.ImpexFinance,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
  {
    pathName: "admin",
    view: <AdminAccess />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.SupplierAdmin,
      perm.SuperAdmin
    ],
  },
];
